module.exports = __webpack_public_path__ + "19a855ce05ac3aea05d19e40f52f3e8c.jpg";